import { useState, useEffect, useCallback } from "react";
import { axiosInstance, API_ENDPOINTS, getAuthHeaders } from "config/api";

export const useLoginActivity = (filters = {}) => {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    from = "",
    to = "",
    role = "",
    user_id = "",
    page = 1,
    limit = 20,
    enabled = true,
  } = filters;

  const fetchRows = useCallback(
    async (signal) => {
      if (!enabled) {
        setRows([]);
        setTotal(0);
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        const params = { page, limit };
        if (from) params.from = from;
        if (to) params.to = to;
        if (role) params.role = role;
        if (user_id) params.user_id = user_id;

        const response = await axiosInstance.get(
          API_ENDPOINTS.AUDIT.LOGIN_ACTIVITY,
          {
            headers: getAuthHeaders(),
            params,
            signal,
            validateStatus: (status) => status < 500,
          },
        );

        if (response.status >= 200 && response.status < 300 && response.data?.success) {
          setRows(Array.isArray(response.data.data) ? response.data.data : []);
          setTotal(Number(response.data.total || 0));
          setError(null);
        } else {
          setRows([]);
          setTotal(0);
          setError(new Error(response.data?.error || "Failed to load login activity"));
        }
      } catch (err) {
        if (err.name === "CanceledError" || err.message === "canceled") return;
        console.error("Error fetching login activity:", err);
        setRows([]);
        setTotal(0);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [from, to, role, user_id, page, limit, enabled],
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchRows(controller.signal);
    return () => controller.abort();
  }, [fetchRows]);

  return {
    rows,
    total,
    isLoading,
    error,
    refresh: () => fetchRows(),
  };
};
